import {
  isMobile as deviceDetectIsMobile,
  isSafari as deviceDetectIsSafari,
} from 'react-device-detect'

export const isSafari = deviceDetectIsSafari
export const isMobile = deviceDetectIsMobile
